// src/components/Navbar.jsx
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Search, HelpCircle, User, Globe, Lock, LogOut, Menu } from 'lucide-react'; // Adiciona Menu

const itrakerLogoUrl = "https://gerenciamento.itraker.com.br/assets/img/logoITRAKER.png";

// Componente Dropdown (mantido da resposta anterior)
const UserProfileDropdown = ({ onLogout, onChangePassword, onSelectLanguage, dropdownRef }) => {
    // ... (código do UserProfileDropdown da resposta anterior)
    // Adicionei o hover state aqui para ficar completo
    const [hoveredItem, setHoveredItem] = useState(null);
    const getItemStyle = (itemName) => ({
        ...styles.dropdownItem, // Usa o estilo base
        backgroundColor: hoveredItem === itemName ? styles.dropdownItemHover.backgroundColor : 'transparent', // Aplica cor de fundo no hover
    });
    return (
        <div ref={dropdownRef} style={styles.dropdownMenu}>
            <button onClick={onChangePassword} style={getItemStyle('password')} onMouseEnter={() => setHoveredItem('password')} onMouseLeave={() => setHoveredItem(null)}>
                <Lock size={18} style={styles.dropdownIcon} /> Trocar Senha
            </button>
            <div style={styles.dropdownDivider}></div>
        </div>
    );
};


// Componente Navbar modificado
const Navbar = ({ onToggleMobileMenu, isMobile }) => { // Recebe props do Layout
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const initialSearchQuery = queryParams.get("query") || "";

    const [query, setQuery] = useState(initialSearchQuery);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    const dropdownRef = useRef(null);
    const profileButtonRef = useRef(null);

    // Efeito para fechar dropdown (mantido da resposta anterior)
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (isDropdownOpen && dropdownRef.current && !dropdownRef.current.contains(event.target) && profileButtonRef.current && !profileButtonRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };
        if (isDropdownOpen) { document.addEventListener('mousedown', handleClickOutside, true); }
        return () => { document.removeEventListener('mousedown', handleClickOutside, true); };
    }, [isDropdownOpen]);

    const handleSearchSubmit = (e) => { /* ... (mantido) ... */ e.preventDefault(); if (query.trim().length > 0) { navigate(`/resultado?query=${encodeURIComponent(query)}`); } };
    const handleDownloadApp = () => { /* ... (mantido) ... */ console.log("Ação: Baixar o app"); };
    const handleHelp = () => { /* ... (mantido) ... */ console.log("Ação: Abrir ajuda/suporte"); };
    const handleUserProfile = () => { setIsDropdownOpen(prevState => !prevState); };
    const handleLogout = () => { /* ... (mantido) ... */ console.log("Ação: Executar logout"); setIsDropdownOpen(false); };
    const handleChangePassword = () => { /* ... (mantido) ... */ console.log("Ação: Navegar para troca de senha"); setIsDropdownOpen(false); };
    const handleSelectLanguage = () => { /* ... (mantido) ... */ console.log("Ação: Abrir seletor de idioma"); setIsDropdownOpen(false); };

    return (
        <nav style={styles.navbar}>
            <div style={styles.leftSection}>
                {/* Botão Hamburger SÓ APARECE NO MOBILE */}
                {isMobile && (
                    <button onClick={onToggleMobileMenu} style={styles.hamburgerButton} aria-label="Abrir menu">
                        <Menu size={28} color="#333" />
                    </button>
                )}
                {/* Logo */}
                <div style={styles.logoContainer}>
                    <img src={itrakerLogoUrl} alt="iTraker Logo" style={styles.logo} />
                </div>
            </div>

            {/* Centro: Barra de Busca */}
            <div style={styles.searchContainer}>
                {/* ... (código da barra de busca mantido) ... */}
                <form onSubmit={handleSearchSubmit} style={styles.searchForm}>
                    <Search size={20} color="#666" style={styles.searchIcon} />
                    <input type="text" placeholder="Pesquisar" value={query} onChange={(e) => setQuery(e.target.value)} style={styles.searchInput} aria-label="Campo de busca"/>
                </form>
            </div>

            {/* Lado Direito: Ações */}
            <div style={styles.rightSection}>
                <button onClick={handleHelp} style={styles.iconButton} aria-label="Ajuda"><HelpCircle size={24} color="#555" /></button>
                <div style={{ position: 'relative' }}>
                    <button ref={profileButtonRef} onClick={handleUserProfile} style={styles.iconButton} aria-label="Menu do usuário" aria-haspopup="true" aria-expanded={isDropdownOpen}>
                        <User size={24} color="#555" />
                    </button>
                    {isDropdownOpen && (
                        <UserProfileDropdown dropdownRef={dropdownRef} onLogout={handleLogout} onChangePassword={handleChangePassword} onSelectLanguage={handleSelectLanguage} />
                    )}
                </div>
            </div>
        </nav>
    );
};


// --- Estilos da Navbar --- (Combine com os estilos anteriores e adicione/modifique)
const styles = {
    // ... (Todos os estilos da Navbar da resposta anterior) ...
    navbar: { position: 'fixed', top: 0, left: 0, width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: '#ffffff', padding: '0 25px', /* Padding horizontal ajustado */ borderBottom: '1px solid #e0e0e0', zIndex: 1050, /* zIndex maior que o da sidebar desktop */ boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)', boxSizing: 'border-box', height: '65px', },
    leftSection: { display: 'flex', alignItems: 'center', gap: '15px' /* Espaço entre hamburger e logo */},
    hamburgerButton: { background: 'none', border: 'none', cursor: 'pointer', padding: '5px', display: 'flex', alignItems: 'center', justifyContent: 'center', },
    logoContainer: { display: 'flex', alignItems: 'center', },
    logo: { height: '35px', width: 'auto', },
    searchContainer: { flex: 1, maxWidth: '600px', marginLeft: '20px', marginRight: '20px', display: 'flex', alignItems: 'center', },
    searchForm: { position: 'relative', width: '100%', },
    searchInput: { width: '100%', padding: '10px 15px 10px 40px', borderRadius: '20px', border: '1px solid #ccc', fontSize: '15px', outline: 'none', boxSizing: 'border-box', backgroundColor: '#f5f5f5', },
    searchIcon: { position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none', color: '#666', },
    rightSection: { display: 'flex', alignItems: 'center', gap: '20px', },
    linkButton: { background: 'none', border: 'none', color: '#007bff', cursor: 'pointer', fontSize: '14px', fontWeight: '500', padding: '0', textDecoration: 'underline', whiteSpace: 'nowrap', },
    iconButton: { background: 'none', border: 'none', cursor: 'pointer', padding: '5px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '50%', },
    // Estilos do Dropdown (copiados da resposta anterior)
    dropdownMenu: { position: 'absolute', top: 'calc(100% + 10px)', right: 0, backgroundColor: 'white', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)', zIndex: 1100, minWidth: '180px', padding: '8px 0', border: '1px solid #eee', listStyle: 'none', margin: 0, },
    dropdownItem: { display: 'flex', alignItems: 'center', padding: '10px 15px', fontSize: '14px', color: '#333', background: 'none', border: 'none', width: '100%', textAlign: 'left', cursor: 'pointer', transition: 'background-color 0.15s ease-in-out', whiteSpace: 'nowrap', },
    dropdownItemHover: { backgroundColor: '#f5f5f5', }, // Estilo para hover
    dropdownIcon: { marginRight: '10px', color: '#555', flexShrink: 0, },
    dropdownDivider: { height: '1px', backgroundColor: '#e0e0e0', margin: '8px 0', }
};

export default Navbar;